var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import SelectFilter from '@/components/select-filter/SelectFilter';
import AsyncSelect from '@/components/async-select/AsyncSelect';
import LoaderCard from '@/components/loader-card/LoaderCard';
import DataTable from '@/components/data-table/DataTable';
import axios from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { dayMap } from '@/support/CalendarDefaults';
import { DateTime } from 'luxon';
import { identifyApplication, identifyHostname } from '@/support/Client';
import { Token } from '@/support/Token';
import { formatDate as format } from '@/support/String';
let GenerateRosterDialog = class GenerateRosterDialog extends Vue {
    constructor() {
        super(...arguments);
        this.currentStep = 1;
        this.selectedStartDate = '';
        this.weekNumber = 0;
        this.pickerModal = false;
        this.numberOfWeeks = 0;
        this.weeks = [];
        this.isGenerating = false;
        this.formatSelectedStartDate = format;
        this.rules = {
            numberOfWeeks: (value) => value > 0 || 'Must be higher than 0',
        };
    }
    mounted() {
        //
    }
    allowedDates(date) {
        const day = parseInt(DateTime.fromFormat(date, 'yyyy-LL-dd').toFormat('c'));
        const weekStart = this.weekStart === 0 ? 7 : this.weekStart;
        return weekStart === day;
    }
    createWeeks() {
        this.weeks = [];
        for (let index = 0; index < this.numberOfWeeks; index += 1) {
            const week = {
                week: DateTime.fromFormat(this.selectedStartDate, 'yyyy-LL-dd').plus({ days: (index * 7) }).toFormat('yyyy-LL-dd'),
            };
            this.weeks.push(week);
        }
    }
    getWeekNumber(weekStartDate) {
        return DateTime.fromFormat(weekStartDate, 'yyyy-LL-dd').weekNumber.toString();
    }
    calculateEndDate(date) {
        return DateTime.fromFormat(date, 'yyyy-LL-dd').plus({ days: 6 }).toFormat('yyyy-LL-dd');
    }
    generateRoster() {
        this.isGenerating = true;
        const headers = {};
        headers.Authorization = `Bearer ${Token.getAccessToken()}`;
        if (window.location.hostname !== 'localhost') {
            headers['X-Application'] = identifyApplication();
        }
        const client = axios.create({
            baseURL: `${identifyHostname() || ''}`,
            headers,
        });
        client
            .post('v3/roster/plan', this.weeks)
            .then(() => {
            this.isGenerating = false;
            this.currentStep = 4;
            this.$emit('rosterGenerated');
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    get weekStart() {
        const setting = this.$store.state.settings.find((setting) => {
            return setting.key === 'first_day_of_week';
        });
        if (setting) {
            return dayMap[setting.value];
        }
        return 1;
    }
    getTemplateName(id) {
        if (!this.$store.state.filters.RosterTemplate) {
            return '';
        }
        const rosterTemplate = this.$store.state.filters.RosterTemplate.find((rosterTemplate) => {
            return rosterTemplate.value === id;
        });
        if (!rosterTemplate) {
            return '';
        }
        return rosterTemplate.text;
    }
    close() {
        this.$emit('input', false);
        this.clear();
    }
    clear() {
        this.currentStep = 1;
        this.weeks = [];
        this.numberOfWeeks = 0;
    }
    get templatesSelected() {
        let allSelected = true;
        this.weeks.forEach((week) => {
            if (!week.template) {
                allSelected = false;
            }
        });
        return allSelected;
    }
    get canGenerateWeeks() {
        if (this.selectedStartDate.length && this.numberOfWeeks > 0 && /^\d+$/.test(this.numberOfWeeks.toString())) {
            return true;
        }
        return false;
    }
    get minDate() {
        return DateTime.local().toFormat('yyyy-LL-dd');
    }
};
GenerateRosterDialog = __decorate([
    Component({
        components: {
            AsyncSelect,
            SelectFilter,
            LoaderCard,
            DataTable,
        },
        filters: {
            formatDate(date) {
                return !date ? '' : format(date, 'dd-LL-yyyy');
            },
        },
    })
], GenerateRosterDialog);
export default GenerateRosterDialog;
